export const setSessionStorageItem = (key, data) => {
  sessionStorage.setItem(key, JSON.stringify(data));
};

export const removeSessionStorageItem = (key) => {
  sessionStorage.removeItem(key);
};

export const getSessionStorageItem = (key, shouldParseObject = true) => {
  const sessionStorageString = sessionStorage.getItem(key);
  return shouldParseObject ? JSON.parse(sessionStorageString) : sessionStorageString;
};
